document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector("#accessoires_offerts");
  if (!input || !input.value) {
    console.log("ℹ️ Pas d'accessoires_offerts sur ce produit.");
    return;
  }

  const mainHandle = input.dataset.mainHandle;
  if (!mainHandle) {
    console.log("⚠️ Pas de data-main-handle sur #accessoires_offerts");
    return;
  }

  console.log("Brut depuis l'input :", input.value);

  let handles;
  try {
    handles = JSON.parse(input.value)
      .map((h) => (typeof h === "string" ? h.trim() : h))
      .filter(Boolean);
  } catch (e) {
    console.error("❌ JSON invalide pour accessoires_offerts :", e);
    return;
  }

  if (!Array.isArray(handles) || !handles.length) {
    console.log("Liste d'accessoires vide ou invalide.");
    return;
  }

  console.log("🎁 Accessoires détectés :", handles);

  const addBtn = document.querySelector('.product-single__form [name="add"]');
  if (!addBtn) {
    console.log("⚠️ Bouton d'ajout au panier introuvable.");
    return;
  }

  let giftsStarted = false;

  addBtn.addEventListener("click", () => {
    if (giftsStarted) return;
    giftsStarted = true;
    waitForMainAndAddGifts();
  });

  async function waitForMainAndAddGifts() {
    // On essaie plusieurs fois, le temps que le thème ajoute le casque
    for (let attempt = 0; attempt < 10; attempt++) {
      let cart;
      try {
        cart = await fetch("/cart.js", {
          credentials: "same-origin",
        }).then((r) => r.json());
      } catch (e) {
        console.error("❌ Impossible de récupérer le panier :", e);
        return;
      }

      const hasMain = cart.items.some(
        (item) =>
          item.handle === mainHandle || item.product_handle === mainHandle
      );

      if (hasMain) {
        console.log("✅ Casque détecté dans le panier, ajout des cadeaux…");
        await addGifts(cart);
        return;
      }

      console.log(
        "🧢 Casque pas encore dans le panier (tentative",
        attempt + 1,
        "), on réessaie…"
      );
      await new Promise((res) => setTimeout(res, 400));
    }

    console.log(
      "⏱ Casque jamais détecté dans le panier après plusieurs essais, j'abandonne l'ajout des cadeaux."
    );
  }

  async function addGifts(cart) {
    for (const handle of handles) {
      try {
        if (
          cart.items.some(
            (i) => i.handle === handle || i.product_handle === handle
          )
        ) {
          console.log(`↩️ Accessoire déjà présent pour handle : ${handle}`);
          continue;
        }

        const resProd = await fetch(`/products/${handle}.js`, {
          credentials: "same-origin",
        });
        if (!resProd.ok) {
          console.warn(
            `⚠️ Produit introuvable pour handle ${handle}, status ${resProd.status}`
          );
          continue;
        }

        const product = await resProd.json();
        const variantId = product.variants[0]?.id;
        if (!variantId) {
          console.warn("⚠️ Pas de variante pour :", product.title);
          continue;
        }

        const body = new URLSearchParams({
          id: String(variantId),
          quantity: "1",
        }).toString();

        const resAdd = await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type":
              "application/x-www-form-urlencoded; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest",
          },
          body,
        });

        if (!resAdd.ok) {
          console.error(
            `❌ Échec ajout accessoire (${product.title}) : status ${resAdd.status}`
          );
          continue;
        }

        const data = await resAdd.json();
        console.log("🎁 Accessoire ajouté (réponse Shopify) :", data);

        // on met à jour notre copie locale du panier pour le test "déjà présent"
        cart.items.push({
          handle,
          product_handle: handle,
        });
      } catch (err) {
        console.error(`❌ Erreur accessoire ${handle}:`, err);
      }
    }
  }

  // Optionnel : relock des quantités pour les produits "offerts"
  const lockGiftItems = () => {
    document.querySelectorAll(".cart-item").forEach((item) => {
      const name = item.innerText.toLowerCase();
      if (name.includes("offert")) {
        const qtyInputs = item.querySelectorAll('input[type="number"]');
        qtyInputs.forEach((input) => {
          input.value = 1;
          input.setAttribute("readonly", "readonly");
          input.style.pointerEvents = "none";
          input.style.opacity = "0.6";
        });

        item.querySelectorAll("button").forEach((btn) => {
          btn.style.pointerEvents = "none";
          btn.style.opacity = "0.5";
        });

        const removeBtn = item.querySelector(
          'button[name="remove"], a[href*="remove"], .cart-remove'
        );
        if (removeBtn) {
          removeBtn.style.pointerEvents = "none";
          removeBtn.style.opacity = "0.5";
        }
      }
    });
  };

  const cartObserver = new MutationObserver(lockGiftItems);
  cartObserver.observe(document.body, { childList: true, subtree: true });
  lockGiftItems();
});
